const PeriodType = Object.freeze({
    Monthly: "Monthly",
    Periodic: "Periodic",
  });

export default PeriodType;